export default "/images/co-img-5.png?9d5bb266ee8153efc8a1313c9c19f126";